mutation UpdateEventName($eventId: ID!, $name: String) {
  event: StreamToolsUpdateEvent(eventId: $eventId, name: $name) {
    eventId
    name
    description
  }
}
